import { useStaticQuery, graphql } from "gatsby";
import { PollenConsultCtaBanner } from "../Types/AcfGroupTypes/PollenConsultCtaBanner.type";

export const PollenConsultBannerQuery = (): PollenConsultCtaBanner => {
  const {
    wp: {
      pollenOptionsSettings: { pollenConsultCtaBanner },
    },
  } = useStaticQuery(graphql`
    {
      wp {
        pollenOptionsSettings {
          pollenConsultCtaBanner {
            addConsultCtaBanner
            consultCtaHeadline
            consultCtaLink
            consultCtaText
            consultCtaImageBackground {
              altText
              localFile {
                childImageSharp {
                  fluid(quality: 90, maxWidth: 1920) {
                    ...GatsbyImageSharpFluid_withWebp
                  }
                }
              }
            }
          }
        }
      }
    }
  `);

  return pollenConsultCtaBanner;
};
